module.exports = __webpack_public_path__ + "img/learn-3-on.1d859d54.png";